import ConfigForm from './ConfigForm.jsx';

const isRepeatable = (config) => 'repeat_min' in config || 'repeat_max' in config;

const SCHEMA = [
  { key: 'layout', label: 'Layout', kind: 'select', options: ['stacked', 'table'] },
  { key: 'style', label: 'Style', kind: 'select', options: [
    { value: 'well', label: 'Well — inset panel' },
    { value: 'alert_info', label: 'Info — blue' },
    { value: 'alert_warning', label: 'Warning — yellow' },
    { value: 'alert_danger', label: 'Danger — red' },
    { value: 'alert_success', label: 'Success — green' },
  ] },
  { key: 'repeat_min', label: 'Repeat min', kind: 'integer' },
  { key: 'repeat_max', label: 'Repeat max', kind: 'integer' },
  // Action-bar options only mean anything once the group repeats — a plain group
  // renders no add/remove/reorder controls. Key presence, not truthiness:
  // `repeat_min: 0` is valid and falsy (mirrors isRepeatableGroup in the renderer).
  { key: 'actionbar_labels.add', label: 'Add button label', kind: 'text', showIf: isRepeatable },
  { key: 'actionbar_labels.remove', label: 'Remove button label', kind: 'text', showIf: isRepeatable },
  { key: 'collapsible', label: 'Collapsible', kind: 'boolean' },
  { key: 'reorderable', label: 'Allow reordering rows', kind: 'boolean', default: true, showIf: isRepeatable },
];

export default function GroupConfig({ field, onConfigChange }) {
  return <ConfigForm schema={SCHEMA} config={field.config} onConfigChange={onConfigChange} />;
}
